// chatUnread.js — the unread count on the sidebar's Chat entry.
//
// Polls /chat/unread every 20 s while the tab is visible (the backend answers from memory, so this
// costs no warehouse query), and takes the Chat page's own count the moment it changes — the page
// fires a `chat-unread` event on every list update, so the badge never lags what is on screen.
import { useEffect, useState } from 'react';
import { API_BASE } from './dataEntryApi';

const POLL_MS = 20000;

export function useChatUnread(username, enabled) {
  const [total, setTotal] = useState(0);
  useEffect(() => {
    if (!enabled || !username) { setTotal(0); return undefined; }
    let alive = true;
    let timer = null;
    let busy = false;
    const tick = async () => {
      if (busy) return;
      busy = true;
      if (!document.hidden) {
        try {
          const res = await fetch(`${API_BASE}/chat/unread?user=${encodeURIComponent(username)}`);
          if (res.ok) {
            const d = await res.json();
            if (alive) setTotal(d.total || 0);
          }
        } catch { /* backend asleep — try again next round */ }
      }
      busy = false;
      if (alive) timer = setTimeout(tick, POLL_MS);
    };
    tick();
    const onEvent = (e) => setTotal(Number(e.detail) || 0);
    const onVisible = () => { if (!document.hidden) { clearTimeout(timer); tick(); } };
    window.addEventListener('chat-unread', onEvent);
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      alive = false;
      clearTimeout(timer);
      window.removeEventListener('chat-unread', onEvent);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [username, enabled]);
  return total;
}
